// extracted by mini-css-extract-plugin
module.exports = {"setList":"SetList_setList__2-ifs","setContainer":"SetList_setContainer__d_upz"};